import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { BASE_URL } from '../constants.js'

const rawBaseQuery = fetchBaseQuery({baseUrl: BASE_URL})
const baseQuery = async (args, api, extraOptions) => {
    const result = await rawBaseQuery(args, api, extraOptions);
    const url = typeof args === 'string' ? args : args.url;
    const status = result.error?.status;
    // Payment recovery and optional exchange rates have their own safe retry UI.
    const recoverable = /\/api\/(?:exchange-rates|paypal(?:-standard)?|stripe|orders)(?:\/|$)/.test(url);
    if (api.type === 'query' && !recoverable &&
        (Number(status) >= 500 || status === 'FETCH_ERROR' || status === 'TIMEOUT_ERROR' || status === 'PARSING_ERROR')) {
        window.dispatchEvent(new Event('practidex:unexpected-error'));
    }
    return result;
}

export const apiSlice = createApi({
    baseQuery,
    tagTypes : ['Product', 'Order', 'User', 'Users', 'Notifications', 'Wishlist', 'Follow', 'PaypalSandbox'],
    endpoints: (builder) => ({}),
})
